import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaSaldosDetalle', {
    controller: nominasNominaSaldosDetalleComponent,
    template: template,
    bindings: {
      colaborador: '<',
      idNomina: '<',
      idProyecto: '<',
      idColaborador: '<',
      idMoneda: '<',
      fechaAbono: '<',
      fechaCorte: '<',
      tipoCambio: '<',
      saldo: '<',
      remuneracion: '<',
      onClose: '&',
    },
  })

function nominasNominaSaldosDetalleComponent(NominasNominaSaldosSaldo) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.agregar = agregar
  $ctrl.cerrar = cerrar
  $ctrl.eliminar = eliminar
  $ctrl.procesando = false
  $ctrl.totalizar = totalizar

  function $onInit() {
    $ctrl.moneda_1 = $ctrl.idMoneda === 1 ? 'MXN' : 'USD'
    $ctrl.moneda_2 = $ctrl.idMoneda === 2 ? 'MXN' : 'USD'

    $ctrl.promise = NominasNominaSaldosSaldo.get($ctrl.idNomina, $ctrl.idProyecto, $ctrl.idColaborador, $ctrl.idMoneda)
      .then(function (response) {
        $ctrl.nominas = response.data.nominas
        $ctrl.saldos = response.data.saldos
        $ctrl.movimientos = []

        totalizar()
      })
  }

  function aceptar() {
    if ($ctrl.procesando)
      return

    $ctrl.procesando = true

    let notas = 'Ajuste cambiario tc: ' + $ctrl.tipoCambio,
      movimientos = $ctrl.movimientos.map(function (item) {
        return {
          abono: {
            id_concepto: item.abono.id_concepto,
            id_moneda: item.abono.id_moneda,
            id_operadora: item.abono.id_operadora,
            naturaleza: 'A',
            fecha: item.abono.fecha,
            importe: item.abono.importe,
            notas: notas,
          },
          cargo: {
            id_concepto: item.cargo.id_concepto,
            id_moneda: item.cargo.id_moneda,
            id_operadora: item.cargo.id_operadora,
            naturaleza: 'C',
            fecha: item.cargo.fecha,
            importe: item.cargo.importe,
            notas: notas,
          },
        }
      })

    NominasNominaSaldosSaldo.post($ctrl.idNomina, $ctrl.idProyecto, $ctrl.idColaborador, {movimientos: movimientos})
      .then(function () {
        cerrar({
          id_moneda: $ctrl.idMoneda,
          cargos: $ctrl.total.cargos,
          abonos: $ctrl.total.abonos,
        })
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }

  function agregar(data) {
    $ctrl.agregando = false

    if (data)
      $ctrl.movimientos.push(data)
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}})
  }

  function eliminar(item) {
    $ctrl.movimientos = $ctrl.movimientos.filter(function (movimiento) {
      return movimiento !== item
    })

    totalizar()
  }

  function totalizar() {
    $ctrl.error = false
    $ctrl.total = {
      cargos: 0,
      abonos: 0,
    }

    $ctrl.nominas.map(function (nomina) {
      nomina.descuentos = $ctrl.movimientos
        .filter(function (movimiento) {
          return movimiento.cargo.id_operadora === nomina.id_operadora
        })
        .reduce(function (total, movimiento) {
          return redondear(total + movimiento.cargo.importe)
        }, 0)

      $ctrl.total.cargos = redondear($ctrl.total.cargos + nomina.descuentos)

      nomina.total = redondear(nomina.importe - nomina.descuentos)

      if (nomina.total < 0)
        $ctrl.error = true

    })

    $ctrl.saldos.map(function (saldo) {
      saldo.abonos = $ctrl.movimientos
        .filter(function (movimiento) {
          return movimiento.abono.id_operadora === saldo.id_operadora
            && movimiento.abono.id_concepto === saldo.id_concepto
        })
        .reduce(function (total, movimiento) {
          return redondear(total + movimiento.abono.importe)
        }, 0)

      $ctrl.total.abonos = redondear($ctrl.total.abonos + saldo.abonos)

      saldo.total = redondear(saldo.importe - saldo.abonos)

      if (saldo.total < 0)
        $ctrl.error = true
    })
  }

  function redondear(numero) {
    return parseFloat(numero.toFixed(2))
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/saldos/detalle/component.js